import BaseType from "../BaseType";
import EnumerationListItem from "./EnumerationListItem";

export default class EnumerationList extends BaseType {
  Name: string = "";
  EnumerationItems: EnumerationListItem[] = [];
  SystemName: string | null = null;
}
